import { NavigationHistoryBar } from "@circle-react-shared/uikit/HeaderV3/NavigationHistoryBar";

import { MainAppContent } from "./index";
import type { MainAppContentProps } from "./types";

export const ElectronAppWrapper = (props: MainAppContentProps) => (
  <div className="flex h-screen w-full flex-col">
    <NavigationHistoryBar />
    <div className="flex min-h-0 flex-1 overflow-hidden">
      <MainAppContent {...props} />
    </div>
  </div>
);
